import { api, unwrap } from './client';
import { reservationFromApi } from './_transforms';

export async function listReservations({ q, status, eventId, page = 0, size = 20, sort = 'createdAt,desc' } = {}) {
  const params = { page, size, sort };
  if (q) params.q = q;
  if (status) params.status = status.toUpperCase();
  if (eventId) params.eventId = eventId;
  const data = await unwrap(api.get('/api/reservations', { params }));
  return {
    content: (data.content || []).map(reservationFromApi),
    totalElements: data.totalElements,
    totalPages: data.totalPages,
    number: data.number,
  };
}

export function getReservationSummary() {
  return unwrap(api.get('/api/reservations/summary'));
}

export async function getReservation(id) {
  const data = await unwrap(api.get(`/api/reservations/${id}`));
  return reservationFromApi(data);
}

export async function recheckReservation(id) {
  const data = await unwrap(api.post(`/api/reservations/${id}/recheck`));
  return reservationFromApi(data);
}

export async function cancelReservation(id) {
  const data = await unwrap(api.post(`/api/reservations/${id}/cancel`));
  return reservationFromApi(data);
}
